export default {
    formId: 'createCompanyForm', //'checkoutForm',
    formField: {
      type_document: {
        name: 'type_document',
        label: 'Tipo de documento',
        requiredErrorMsg: 'Tipo de documento es requerido.'
      },
      number_document: {
        name: 'number_document',
        label: 'Numero de documento*',
        requiredErrorMsg: 'Numero de documento es requerido.',
        typeDataMsg: 'El campo es numerico.'
      },
      tradename: {
        name: 'tradename',
        label: 'Nombre comercial*',
        requiredErrorMsg: 'Nombre comercial es requerido.'
      },
      business_name: {
        name: 'business_name',
        label: 'Razon social*',
        requiredErrorMsg: 'La razon social es requerida.'
      },
      legal_representative: {
        name: 'legal_representative',
        label: 'Representante legal*',
        requiredErrorMsg: 'El representante legal es requerido.'
      },
      email: {
        name: 'email',
        label: 'Email*',
        requiredErrorMsg: 'El email  es requerido.'
      },
      manager_in_charge: {
        name: 'manager_in_charge',
        label: 'Gerente*',
        requiredErrorMsg: 'El gerente gerente es requerido.',
      },
      economic_activity: {
        name: 'economic_activity',
        label: 'Actividad Economica*',
        requiredErrorMsg: 'La actividad ecomonica es requerida.',
      },
      branch_offices: {
        name: 'branch_offices',
        label: 'Tiene sucursales?'
      },
      country: {
        name: 'country',
        label: 'Pais',
        requiredErrorMsg: 'El pais es requerido.',
      },
      departament: {
        name: 'departament',
        label: 'Departamento',
        requiredErrorMsg: 'El departamento es requerido.'
      },
      municipaly: {
        name: 'municipaly',
        label: 'Municipio',
        requiredErrorMsg: 'El municipio es requerido.',
        // invalidErrorMsg: 'Card number is not valid (e.g. 4111111111111)'
      },
      address_company: {
        name: 'address_company',
        label: 'Direccion*',
        requiredErrorMsg: 'La direccion es requerida.',
        // invalidErrorMsg: 'Expiry date is not valid'
      },
      workplace: {
        name: 'workplace',
        label: 'Sitio de trabajo',
        requiredErrorMsg: 'El sitio de trabajo es requerido.',
        // invalidErrorMsg: 'CVV is invalid (e.g. 357)'
      },
      landline: {
        name: 'landline',
        label: 'Telefono fijo'
      },
      cell_phone: {
        name: 'cell_phone',
        label: 'Celular'
      },

      // forma de pago 
      payment_frequency: {
        name: 'payment_frequency',
        label: 'Frecuencia de pago',
        requiredErrorMsg: 'Frecuencia de pago es requerida.'
      },
      payment_method: {
        name: 'payment_method',
        label: 'Metodo de pago',
        requiredErrorMsg: 'Metodo de pago es requerido.'
      },
      associated_bank: { 
        name: 'associated_bank',
        label: 'Banco asociado',
        requiredErrorMsg: 'Banco asociado es requerido.'
      },
      type_account_bank: {
        name: 'type_account_bank',
        label: 'Tipo de cuenta',
        requiredErrorMsg: 'Tipo de cuenta es requerida.'
      },
      account_number: {
        name: 'account_number',
        label: 'Numero de cuenta',
        requiredErrorMsg: 'Numero de cuenta es requerido.'
      },


      // SEGURIDAD SOCIAL 
      sgsst: {
        name: 'sgsst',
        label: 'Plataforma para SST',
        requiredErrorMsg: 'Plataforma para SST es requerida.'
      },
      arl: {
        name: 'arl',
        label: 'ARL Vinculada a la empresa',
        requiredErrorMsg: 'ARL Vinculada a la empresa es requerida.'
      },
      constitution_date: {
        name: 'constitution_date',
        label: 'Fecha de Constitución',
        requiredErrorMsg: 'Fecha de Constitución es requerida.'
      },
      ley_1429_2010: {
        name: 'ley_1429_2010',
        label: 'Acoge la ley 1429 de 2010'
      },
      ley_590_2000: {
        name: 'ley_590_2000',
        label: 'Acoge la ley 590 2000'
      },
      ley_1607_2012: {
        name: 'ley_1607_2012',
        label: 'Acoge la ley 1607 2012'
      },
      ley_1607_201a2: {
        name: 'ley_1607_2012',
        label: 'ley 1607 2012'
      },

      // ARCHIVOS 
      rut: {
        name: 'rut',
        label: 'Rut',
        requiredErrorMsg: 'Rut es requerido.'
      },
      rut_name_saved_file: {
        name: 'rut_name_saved_file',
        label: 'rut_name_saved_file',
        requiredErrorMsg: 'Rut es requerido.'
      },
      chamber_of_commerce: {
        name: 'chamber_of_commerce',
        label: 'Camara y comercio',
        requiredErrorMsg: 'Camara y comercio es requerido.'
      },
      chamber_of_commerce_name_saved_name: {
        name: 'chamber_of_commerce_name_saved_name',
        label: 'Camara y comercio',
        requiredErrorMsg: 'Camara y comercio es requerido.'
      },
      bank_certificate: {
        name: 'bank_certificate',
        label: 'Certificado bancario',
        requiredErrorMsg: 'Certificado bancario es requerido.'
      },
      bank_certificate_name_saved_name: {
        name: 'bank_certificate_name_saved_name',
        label: 'Certificado bancario',
        requiredErrorMsg: 'Certificado bancario es requerido.'
      },
      // LOGOS NOMBRE COMERCIAL 
      logo_bn_company: {
        name: 'logo_bn_company',
        label: 'Logo razon social',
        requiredErrorMsg: 'Logo razon social es requerido.'
      },
      logo_bn_rz_company_name_saved_file: {
        name: 'logo_bn_rz_company_name_saved_file',
        label: 'Logo razon social',
        requiredErrorMsg: 'Logo razon social es requerido.'
      },
      logo_bn_post_company: {
        name: 'logo_bn_post_company',
        label: 'Logo compañia',
        requiredErrorMsg: 'Logo compañia es requerido.'
      }, 
      logo_bn_rz_post_company_name_saved_file: {
        name: 'logo_bn_rz_post_company_name_saved_file',
        label: 'Logo compañia',
        requiredErrorMsg: 'Logo compañia es requerido.'
      },
      // LOGOS POST COMERCIAL 
      logo_company: {
        name: 'logo_company',
        label: 'Logo compañia',
        requiredErrorMsg: 'Logo compañia es requerido.'
      },
      logo_company_name_saved_file: {
        name: 'logo_company_name_saved_file',
        label: 'Logo compañia',
        requiredErrorMsg: 'Logo compañia es requerido.'
      },
      logo_post_company: {
        name: 'logo_post_company',
        label: 'Logo post compañia',
        requiredErrorMsg: 'Logo post compañia es requerido.'
      },
      logo_post_company_name_saved_file: {
        name: 'logo_post_company_name_saved_file',
        label: 'Logo post compañia',
        requiredErrorMsg: 'Logo post compañia es requerido.'
      },
    }
  };
  